.riskNameContainer {
    display: flex;
    min-width: 150px;
    max-width: 250px;
}

.controlEnvironmentEffectivenessContainer {
    display: flex;
    gap: 5px;
    align-items: center;
}

.controlEnvironmentContainer {
    display: flex;
    flex-direction: column;
}